import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import MasterGamesList from "../data/MasterGamesList"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function JellyExpress({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const data = promotionsData.find(
    (promo) => promo.title === "Jelly Express Daily Tournament"
  )
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  // promo expired
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Jelly Express Daily Tournament</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>{" "}
              /<span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1>Jelly Express Daily Tournament</h1>
                  <h2>Prize Pool: ₱46,121,600</h2>
                  <div className="promotion-tnc-period">
                    <strong>Event Period: </strong>
                    <span>April 6, 2026 - May 4, 2026</span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong>Terms and Conditions</strong>
                  <ol>
                    <li>
                      161,000 winners will win cash prizes worth ₱ 116,034,800
                      from 6 April 2026, 20:00 to 4 May 2026, 00:59 (GMT+8).
                    </li>
                    <li>
                      There are 28 daily tournaments during the promotion
                      period, running daily from 20:00 to 00:59 (GMT+8).
                    </li>
                    <li>
                      Winners are based on Largest win from a single spin
                      (adjusted for bet value).
                    </li>
                    <li>
                      Scores = (Largest single win during tournament)/(winning
                      bet during tournament)*100
                    </li>
                    <li>No minimum bet is required for this promotion.</li>
                    <li>
                      Players will win prizes in the form of a multiplier of the
                      winning player’s bet amount as set out in the prize table.
                    </li>
                    <li>
                      If the winning spin exceeds ₱58, the prize will be paid
                      out based on a bet of ₱58 X multiplier received.
                    </li>
                    <li>
                      If there are two or more players with identical score in
                      tournament leaderboard, the player who scores it first
                      will get the higher position on the leaderboard.
                    </li>
                    <li>
                      The tournament leaderboard is built in the qualifying
                      games and updates in real time.
                    </li>
                    <li>
                      Pragmatic Play reserves the right to thoroughly review
                      players activities to identify any potential abuse to
                      ensure fair play within our Network Promotion. If any
                      abuse is found, Pragmatic Play reserves the right to
                      forfeit any amounts paid to winning players.
                    </li>
                    <li>
                      Pragmatic Play reserves the right to amend, suspend or
                      cancel the promotion at any time and without prior notice.
                    </li>
                  </ol>

                  {!isAppPromo && (
                    <>
                      <strong>Featured Game</strong>
                      <MasterGamesList
                        qualifiedGamesOnly="on"
                        customQualifiedGames={[
                          {
                            provider: "pp",
                            gameName: "Jelly Express",
                          },
                        ]}
                        limit={2}
                        headerText={null}
                        linkTo={null}
                        headerTag="h2"
                      />
                    </>
                  )}

                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <th>Rank</th>
                        <th>Daily Prizes</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>x3,000</td>
                        </tr>
                        <tr>
                          <td>2-3</td>
                          <td>x1,000</td>
                        </tr>
                        <tr>
                          <td>4-10</td>
                          <td>x200</td>
                        </tr>
                        <tr>
                          <td>11-40</td>
                          <td>x100</td>
                        </tr>
                        <tr>
                          <td>41-400</td>
                          <td>x50</td>
                        </tr>
                        <tr>
                          <td>401-1100</td>
                          <td>x10</td>
                        </tr>
                        <tr>
                          <td>1101-11000</td>
                          <td>x8</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="promotion-tnc-cta">
                    <a
                      href="https://pp88.asia/tl/jelly-express-daily-tournaments/"
                      className="promotion-cta-btn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      View Full T&C
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
